import { Grid, Typography } from "@mui/material"
import { ValidationErrorPayload } from "utils/http"

type ValidationErrorListProps = {
  payload: ValidationErrorPayload
}

const ValidationErrorList = ({ payload }: ValidationErrorListProps) => {
  return (
    <Grid container direction="column">
      <Grid item>
        <Typography>Validation errors:</Typography>
      </Grid>
      <Grid item>
        <ul>
          {payload.detail.map((error, i) => (
            <li key={i}>{`${error.loc?.[1]} - ${error.msg}`}</li>
          ))}
        </ul>
      </Grid>
    </Grid>
  )
}

export default ValidationErrorList
